export const refHeightsDefaults = {
  globalNavHeight: 73.2,
  utilityNavHeight: 79.5,
  headerHeight: 151,
  pageNavMobileHeight: 50,
};
